import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select } from 'antd';

export interface ICountrySelectProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  onChange: (e: any, country: GQL.ICountry | undefined) => void;
  value: string | undefined;
  countries?: Array<GQL.ICountry>;
  hideRegions?: boolean;
  style?: any;
}

export class CountrySelect extends React.PureComponent<ICountrySelectProps> {

  public static defaultProps = {
    hideRegions: true,
  };

  constructor(props: ICountrySelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, countries, hideRegions } = this.props;

    if (countries) {
      // objekt vybrané země
      const country = countries.find((c: GQL.ICountry) => c.id === value || c.name === value);

      return (
        <Select
          showSearch={true}
          placeholder={'Choose country'}
          value={country ? country.id : value}
          style={...style}
          onChange={this.onChange}
          filterOption={(input: string, option: any) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {countries
            .filter((c: GQL.ICountry) => (hideRegions && c.code !== null && c.code !== undefined && c.code !== '') || !hideRegions)
            .map(l => {
              return (
                <Select.Option key={l.id} value={l.id}>
                  {l.name}
                </Select.Option>
              );
            })}
        </Select>
      );
    }

    return (
      <Select placeholder={'Choose country'} style={...style} />
    );
  }

  private onChange(value: string) {
    const { countries } = this.props;

    const country = countries && countries.find((l: GQL.ICountry) => l.id === value);

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      }, country);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/CountrySelect/CountrySelect.tsx